/*
 * Returns true if fn is a function and fn(...params) is true or fn is not a falsy value.
 */
export const condition = (fn, ...params) =>
  (typeof fn === 'function' && fn(...params)) || fn;
